import { FC } from 'react';
import { Image } from 'antd';
import { t } from 'i18next';
import { TerminalAccountBox } from 'components/Shared/TerminalAccountBox';
import * as StyledShared from '../../styles';
import SuccessSmall from 'assets/images/payment/success-small.gif';

interface INftPurchaseSuccessProps {
  isParticipatingInRaffle?: boolean;
}

export const NftPurchaseSuccess: FC<INftPurchaseSuccessProps> = ({
  isParticipatingInRaffle
}) => {
  return (
    <>
      <Image
        src={SuccessSmall}
        preview={false}
        height={230}
        width="100%"
        alt={t('payment.partyPopperAlt')}
        style={{ objectFit: 'cover' }}
      />
      <StyledShared.MessageTitle>
        {t(`payment.success${isParticipatingInRaffle ? 'Raffle' : ''}`)}
      </StyledShared.MessageTitle>
      <StyledShared.MessageSubtitle>
        {t(
          `payment.paymentSuccessful${isParticipatingInRaffle ? 'Raffle' : ''}`
        )}
      </StyledShared.MessageSubtitle>
      <br />
      <TerminalAccountBox size="small" />
    </>
  );
};
